/* 用户相关接口 */
import http from "./request";

// 用户登录
export function useLogin(params) {
	return http("/user/login", {
		method: "POST",
		params: params
	});
}

// 登出
export function userExit() {
	return http("/user/logout", {
		method: "POST",
		params: {}
	});
}

// 注销
export function userDestroy() {
	return http("/user/logOff", {
		method: "POST",
		params: {}
	});
}

// 修改昵称
export function updateUserName(params) {
	return http("/user/updateNickname", {
		method: "POST",
		params: params
	});
}

// 获取验证码
export function getVerifyCode(params) {
	return http("/user/getVerifyCode", {
		method: "POST",
		params: params
	});
}

// 修改手机号
export function updatePhone(params) {
	return http("/user/updatePhone", {
		method: "POST",
		params: params
	});
}

// 修改密码
export function updatePassword(params) {
	return http("/user/updatePwd", {
		method: "POST",
		params: params
	});
}
